module.exports = __webpack_public_path__ + "static/img/pic_toptitlle_jz@2x.cdf40009.png";